export default "__VITE_ASSET__994b2a72__"